import { combineReducers } from 'redux'

import { actions } from '../constants'

export const initial = {
  activeTab: 'general',
  loading: {},
}

export function activeTab(state = initial.activeTab, { type, payload }) {
  switch (type) {
    case actions.SWITCH_TAB:
      return payload.tab.name

    default:
      return state
  }
}

export function loading(state = initial.loading, { type, payload }) {
  switch (type) {
    case actions.data.FETCH:
      return {
        ...state,
        [payload.page]: true,
      }

    case actions.data.FETCH_SUCCESS:
    case actions.data.FETCH_FAILURE:
      return {
        ...state,
        [payload.page]: false,
      }

    default:
      return state
  }
}

export default combineReducers({
  activeTab,
  loading,
})
